import React, { useMemo } from 'react';

import { ReportTypeKeys } from '../report.types';
import ReportSection from '../ReportSection';
import { useFavoriteReportsStore } from '../stores';

import DelinquentClaimsReportCard from './DelinquentClaimsReportCard/DelinquentClaimsReportCard';
import ReplenishmentInvoiceCard from './ReplenishmentInvoiceCard/ReplenishmentInvoiceCard';
import UndeliverableMailReportCard from './UndeliverableMailReportCard/UndeliverableMailReportCard';
import CardStatusCard from './CardStatusCard';
import CIPStatusCard from './CIPStatusCard';
import ClaimsActivityReportCard from './ClaimsActivityReportCard';
import ContributionInvoiceCard from './ContributionInvoiceCard';
import EmployeeDemographicCard from './EmployeeDemographicCard';
import ForfeitureCard from './ForfeitureCard';
import HealthPlanEnrollmentCard from './HealthPlanEnrollmentCard';
import ParticipantActivityReportCard from './ParticipantActivityReportCard';
import PayrollReportCard from './PayrollReportCard';
import PlanOmnibusBalanceReportCard from './PlanOmnibusBalanceReportCard';
import PrefundInvoiceCard from './PrefundInvoiceCard';
const ReportFavoriteCards = () => {
  const keys = useFavoriteReportsStore((state) => state.reportKeys);

  const nodes = useMemo(() => {
    const result: React.ReactNode[] = [];

    keys.forEach((key) => {
      if (key === ReportTypeKeys.PrefundInvoiceCard) {
        result.push(<PrefundInvoiceCard isFavoriteMode />);
      }
      if (key === ReportTypeKeys.ReplenishmentInvoice) {
        result.push(<ReplenishmentInvoiceCard isFavoriteMode />);
      }

      if (key === ReportTypeKeys.ContributionInvoice) {
        result.push(<ContributionInvoiceCard isFavoriteMode />);
      }
      if (key === ReportTypeKeys.HealthPlanEnrollment) {
        result.push(<HealthPlanEnrollmentCard isFavoriteMode />);
      }
      if (key === ReportTypeKeys.ParticipantActivity) {
        result.push(<ParticipantActivityReportCard isFavoriteMode />);
      }
      if (key === ReportTypeKeys.ClaimsActivity) {
        result.push(<ClaimsActivityReportCard isFavoriteMode />);
      }
      if (key === ReportTypeKeys.Payroll) {
        result.push(<PayrollReportCard isFavoriteMode />);
      }

      if (key === ReportTypeKeys.Forfeiture) {
        result.push(<ForfeitureCard isFavoriteMode />);
      }
      if (key === ReportTypeKeys.PlanOmnibusBalance) {
        result.push(<PlanOmnibusBalanceReportCard isFavoriteMode />);
      }

      if (key === ReportTypeKeys.CIPStatus) {
        result.push(<CIPStatusCard isFavoriteMode />);
      }
      if (key === ReportTypeKeys.EmployeeDemographic) {
        result.push(<EmployeeDemographicCard isFavoriteMode />);
      }

      if (key === ReportTypeKeys.CardStatus) {
        result.push(<CardStatusCard isFavoriteMode />);
      }
      if (key === ReportTypeKeys.UndeliverableAddress) {
        result.push(<UndeliverableMailReportCard isFavoriteMode />);
      }
      if (key === ReportTypeKeys.DelinquentClaims) {
        result.push(<DelinquentClaimsReportCard isFavoriteMode />);
      }
    });

    return result;
  }, [keys]);
  const count = useMemo(() => nodes?.length || 0, [nodes?.length]);
  return (
    <ReportSection isLargeMode disabled={!count} title={`Favorite (${count})`}>
      {nodes.map((node) => node)}
    </ReportSection>
  );
};

export default ReportFavoriteCards;
